import Vue from 'vue'
import AppModale from '@/AppModale.vue'

(() => {

  const MODAL_SELECTOR = '#top_bar';

  // Configuration
  Vue.config.productionTip = false

  // Modale
  if ( document.querySelector(MODAL_SELECTOR) !== null ) {
    new Vue({
      render: h => h(AppModale)
    }).$mount(MODAL_SELECTOR)
    console.log('🖼️ Modale Cejcaen démarrée')
  }

})()
